export default __webpack_public_path__ + "static/media/gaming-room.fbdda9fe.jpeg";